// DevHub: shared open/close + click-outside behaviour for the header dropdowns
// (nav / profile / starred). Returns the open flag, its setter, and a ref to
// attach to the dropdown root; clicking outside that root closes it.
import { useEffect, useRef, useState } from 'react';

export function useDropdown() {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!open) return undefined;
    const onPointerDown = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', onPointerDown);
    return () => document.removeEventListener('mousedown', onPointerDown);
  }, [open]);

  return { open, setOpen, ref };
}
